import { Checkbox, Dialog, FormControlLabel, Popover, Tooltip } from "@mui/material";
import { ArrowLeft, Eye, Filter, X } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext, useEffect, useRef, useState } from "react";
import { StarFill } from "react-bootstrap-icons";
import { useParams } from "react-router-dom";
import API from "../../API/newIndex";
import { DataLoad } from "../../App";
import { NOPHOTO_IMAGE, NOUSER_IMAGE } from "../../Assets/StaticData/StaticImage";
import Breadcrumbs from "../../controllers/breadCrumbs";
import { formatDate } from "../../controllers/FormatAmount";
import MuiSwitch from "../../controllers/MuiSwitch";
import { getInitialPage, replacePageInUrl } from "../../controllers/PageHandleFromQuery";
import { parentNavigate } from "../../controllers/ParentNavigate";
import { Transition } from "../../controllers/Transition";
import NoDataFound from "../Main/NoDataFound";
import Notification from "../Notification";
import { useLastRoute } from "../../controllers/LastRouteContext";
import {
  ButtonComponent,
  CommonTable,
  PaginationComponent,
  PageLimitDropDownComponent,
  SearchComponent,
  SelectComponent,
} from "@shopeasy-dashboard-ui/ui-library";

const PerticularReviews = () => {
  const params = useParams();
  const [nodata, setNodata] = useState(false);
  const [clearRow, setClearRow] = useState(false);
  const [Page, setPage] = useState(getInitialPage());
  const initialLimit = localStorage.getItem("limit") || "10";
  const { dataLoading, setDataLoading } = useContext(DataLoad);
  const [limit, setLimit] = useState(initialLimit);
  const [popUp, setPopUp] = useState(false);
  const [ProdutReviews, setProductReviews] = useState();
  const [allReviewname, setAllReviewname] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch((prev) => {
        if (prev !== searchQuery) {
          setPage(1);
        }
        return searchQuery;
      });
    }, 400);
    return () => clearTimeout(handler);
  }, [searchQuery]);
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [filter, setFilter] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const lastRoute = useLastRoute();

  const [selectedRowsId, setSelectedRowsId] = useState([]);
  var startRecord = (ProdutReviews?.data?.currentPage - 1) * (limit === "all" ? ProdutReviews?.data?.totalRecords || 1 : limit) + 1;
  var endRecord = limit === "all" ? ProdutReviews?.data?.totalRecords : Math.min(
    ProdutReviews?.data?.currentPage * limit,
    ProdutReviews?.data?.totalRecords,
  );
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    replacePageInUrl(Page);
  }, [Page]);

  const GetProductReviews = async () => {
    setDataLoading(true);
    try {
      const searchParam = debouncedSearch.trim()
        ? `&searchkey=${encodeURIComponent(debouncedSearch.trim())}`
        : "";
      let ApiCall = await API({
        url: `/admin/review/getProductReviews/${params.reviews_id}?page=${Page}&limit=${limit}&review_type=${allReviewname}${searchParam}`,
        method: "get",
      });
      const result = ApiCall?.data;
      setProductReviews(result);
      if (Number(startRecord) > Number(result?.data?.totalRecords)) {
        setPage(Page - 1);
      }
    } catch (error) {
      setNodata(true);
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    } finally {
      setDataLoading(false);
    }
  };
  const [popdata, setPopData] = useState();

  //Disable Review
  const DisableReview = async (id, value) => {
    try {
      const payload = {
        is_visible: value,
      };
      await API({ url: `/admin/review/UpdateReview/${id}`, method: "put", data: payload });
      GetProductReviews();
      setIsNotification(true);
      setNotificationMsg(value ? "Review is set to active" : "Review is set to hidden");
      setSeverity("success");
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  // Table And Data
  const [productData, setProductData] = useState({
    name: "",
    image: "",
  });
  let tableData = ProdutReviews?.data?.records;
  useEffect(() => {
    setProductData({
      name: tableData && tableData[0]?.product?.product_name,
      image: tableData && tableData[0]?.product?.image,
    });
  }, [tableData]);

  const handleSelectRow = (id) => {
    if (id === "all") {
      if (selectedRowsId?.length > 0) {
        setSelectedRowsId([]);
      } else {
        setSelectedRowsId(ProdutReviews?.data?.records?.map((x) => x?._id));
      }
    } else {
      const existId = selectedRowsId?.length > 0 && selectedRowsId?.find((x) => x === id);
      if (!existId) {
        setSelectedRowsId([...selectedRowsId, id]);
      } else {
        const removeSelected = selectedRowsId?.filter((x) => x !== id);
        setSelectedRowsId(removeSelected);
      }
    }
  };

  // Update Multiple Review
  const UpdateMultipleReview = async (value) => {
    try {
      const payload = {
        id: selectedRowsId,
        is_visible: value,
      };
      await API({ url: "/admin/review/UpdateManyReview", method: "put", data: payload });
      GetProductReviews();
      setSelectedRowsId([]);
      setClearRow(!clearRow);
      setIsNotification(true);
      setNotificationMsg(`Review set to ${value ? "active" : "hidden"}`);
      setSeverity("success");
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  useEffect(() => {
    GetProductReviews();
  }, [allReviewname, Page, limit, debouncedSearch]);

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  const resetFilter = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setFilter(false);
    setAnchorEl(null);
    setSearchQuery("");
    setDebouncedSearch("");
    setPage(getInitialPage() || 1);
    setLimit(limit === "all" ? 10 : limit);
  };

  const displayRecords = ProdutReviews?.data?.records || [];

  // Columns definition for CommonTable
  const columns = [
    {
      key: "checkbox",
      title: (
        <Checkbox
          checked={
            ProdutReviews?.data?.records?.length > 0 &&
            selectedRowsId?.length === ProdutReviews?.data?.records?.length
          }
          indeterminate={
            selectedRowsId?.length !== ProdutReviews?.data?.records?.length &&
            selectedRowsId?.length > 0
          }
          onChange={() => handleSelectRow("all")}
        />
      ),
      headerClassName: "px-3 table-head-checkbox",
      cellClassName: "px-3 table-body-checkbox",
      width: "40px",
      ignoreRowClick: true,
      render: (elem) => (
        <Checkbox
          disabled={elem?.default}
          checked={
            selectedRowsId?.length > 0 && !!selectedRowsId?.find((x) => x === elem?._id)
          }
          onChange={() => handleSelectRow(elem?._id)}
        />
      ),
    },
    {
      key: "user",
      title: <span className="capitalize">{t("lang_user")}</span>,
      headerClassName: "min-w-[180px] max-w-[180px] px-3 capitalize",
      cellClassName: "min-w-[180px] max-w-[180px] px-3",
      render: (elem) => (
        <Tooltip title={elem?.name || "-"} arrow placement="top-start">
          <div
            className={`flex items-center ${
              elem?.verify_status ? "cursor-pointer" : ""
            } space-x-2 text-sm max-w-full overflow-hidden`}
            onClick={() =>
              elem?.verify_status
                ? parentNavigate(`/customers/${elem?.user?._id}`)
                : ""
            }
          >
            <span className="truncate block">{elem?.name || "-"}</span>
          </div>
        </Tooltip>
      ),
    },
    {
      key: "email",
      title: t("lang_email"),
      headerClassName: "min-w-[200px] max-w-[200px] px-3",
      cellClassName: "min-w-[200px] max-w-[200px] px-3",
      render: (elem) => {
        const emailStr = elem?.user?.email || elem?.email || "-";
        return (
          <Tooltip title={emailStr} arrow placement="top-start">
            <div className="flex items-center space-x-2 text-sm max-w-full overflow-hidden">
              <span className="truncate block max-w-[180px]">{emailStr}</span>
            </div>
          </Tooltip>
        );
      },
    },
    {
      key: "rating",
      title: t("lang_Rating"),
      headerClassName: "min-w-[100px] max-w-[100px] px-3",
      cellClassName: "min-w-[100px] max-w-[100px] px-3",
      render: (elem) => {
        const rating = elem?.rating;
        const bgClass =
          rating >= 5
            ? "bg-[#00b67a]"
            : rating >= 4
              ? "bg-[#73cf11]"
              : rating >= 3
                ? "bg-[#ffce00]"
                : rating >= 2
                  ? "bg-[#ff8622]"
                  : "bg-[#ff3722]";
        return rating !== undefined && rating !== null ? (
          <div
            className={`inline-flex items-center space-x-2 ${bgClass} text-white px-3 py-0.5 rounded-[6px]`}
          >
            <StarFill />
            <span className="font-medium text-sm">{rating}</span>
          </div>
        ) : null;
      },
    },
    {
      key: "comment",
      title: <span className="capitalize">{t("lang_comment")}</span>,
      headerClassName: "w-full px-3 capitalize",
      cellClassName: "w-full px-3",
      render: (elem) => (
        <div
          className="block cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            setPopUp(true);
            setPopData(elem);
          }}
        >
          <p className="line-clamp-2 text-left">
            {elem?.description
              ? elem?.description.replace(/<[^>]*>/g, " ")
              : elem?.review
                ? elem?.review
                : "-"}
          </p>
        </div>
      ),
    },
    {
      key: "date",
      title: <span className="text-right w-full capitalize">{t("lang_date")}</span>,
      align: "text-right",
      headerClassName: "min-w-[150px] max-w-[150px] px-3 text-right capitalize",
      cellClassName: "min-w-[150px] max-w-[150px] px-3 text-right",
      render: (elem) => (
        <p className="text-right w-full">
          {elem?.review_date ? formatDate(elem?.review_date) : "-"}
        </p>
      ),
    },
    {
      key: "action",
      title: <span className="text-right w-full capitalize">{t("lang_action")}</span>,
      align: "text-right",
      headerClassName: "min-w-[120px] max-w-[120px] px-3 text-right capitalize",
      cellClassName: "min-w-[120px] max-w-[120px] px-3 text-right",
      ignoreRowClick: true,
      render: (elem) => (
        <div className="flex items-center space-x-2 justify-end w-full">
          <div>
            <label className="relative flex justify-end w-full">
              <FormControlLabel
                checked={elem?.is_visible}
                control={<MuiSwitch />}
                onChange={() => {
                  DisableReview(elem._id, !elem?.is_visible);
                }}
              />
            </label>
          </div>
          <div>
            <Tooltip title="Show" arrow>
              <button className="">
                <Eye
                  className="-800 w-[18px] h-[18px]"
                  onClick={(e) => {
                    e.preventDefault();
                    setPopUp(true);
                    setPopData(elem);
                  }}
                />
              </button>
            </Tooltip>
          </div>
        </div>
      ),
    },
  ];

  // Options for review type select
  const reviewTypeOptions = [
    { value: "", label: t("lang_all") },
    { value: "1", label: t("lang_Registered_Users") },
    { value: "2", label: t("lang_Guest_Users") },
  ];

  // Options for items limit select
  const limitOptions = [
    { value: "10", label: "10" },
    { value: "20", label: "20" },
    { value: "50", label: "50" },
    { value: "all", label: t("lang_all") },
  ];

  const tableHeader = (
    <div className="flex items-center justify-between gap-2 px-4 py-3 border-b main-border-color bg-[var(--secondary-bg-color)] min-h-[52px]">
      <div className="flex items-center gap-3 shrink-0">
        {productData?.name && (
          <div className="flex items-center">
            <div className="h-9 w-9 rounded-full overflow-hidden shrink-0 border border-[var(--border-color)]">
              <img
                className="max-w-full max-h-full object-contain object-top"
                onError={(e) => {
                  e.target.src = NOPHOTO_IMAGE;
                }}
                src={productData?.image || NOPHOTO_IMAGE}
                alt={productData?.name}
              />
            </div>
            <h6 className="text-sm md:text-base ms-2.5 font-semibold text-[var(--primary-text-color)] line-clamp-1 max-w-[150px] sm:max-w-[260px]">
              {productData?.name}
            </h6>
          </div>
        )}

        {selectedRowsId && selectedRowsId?.length > 0 && (
          <div className="flex items-center gap-2 border-l border-[var(--border-color)] pl-3">
            <span className="text-xs font-medium text-[var(--table-text-color)]">{selectedRowsId?.length} Selected</span>
            <ButtonComponent
              variant="secondary"
              size="sm"
              onClick={() => UpdateMultipleReview(false)}
            >
              {t("lang_Hide_Review")}
            </ButtonComponent>
            <ButtonComponent
              variant="secondary"
              size="sm"
              onClick={() => UpdateMultipleReview(true)}
            >
              {t("lang_Show_Review")}
            </ButtonComponent>
          </div>
        )}
      </div>

      <div className="flex items-center gap-2.5 ml-auto shrink-0">
        {/* Desktop View (SS1): Search & Limit */}
        <div className="hidden md:flex items-center gap-2.5">
          <div className="w-48 lg:w-64">
            <SearchComponent
              placeholder="Search Reviews..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target ? e.target.value : (e || ""))}
              onClear={() => setSearchQuery("")}
              size="sm"
            />
          </div>

          <div className="w-20">
            <PageLimitDropDownComponent
              limit={limit}
              setLimit={setLimit}
              setPage={setPage}
              totalRecords={
                ProdutReviews?.data?.totalRecords ||
                ProdutReviews?.data?.records?.length ||
                0
              }
            />
          </div>
        </div>

        {/* Mobile / Responsive View (SS2): Square Filter Icon Button */}
        <div className="block md:hidden">
          <Tooltip title="Filter Options" arrow>
            <ButtonComponent
              variant="outline"
              size="sm"
              className="!w-9 !h-9 !p-0 flex items-center justify-center rounded-lg"
              onClick={(e) => {
                setFilter(!filter);
                setAnchorEl(e.currentTarget);
              }}
            >
              <Filter className="h-4 w-4 text-[var(--table-text-color)]" />
            </ButtonComponent>
          </Tooltip>
        </div>
      </div>
    </div>
  );

  const tableFooter = ProdutReviews?.data && ProdutReviews?.data?.totalPages > 1 ? (
    <PaginationComponent
      count={ProdutReviews?.data?.totalPages}
      page={Page}
      onChange={(e, v) => setPage(v)}
      totalRecords={ProdutReviews?.data?.totalRecords}
      startRecord={startRecord}
      endRecord={endRecord}
      limit={limit}
      recordsLabel="Records"
    />
  ) : null;

  return nodata ? (
    <NoDataFound />
  ) : (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      <div className="h-auto overflow-y-auto overflow-x-hidden pb-[64px] p-5">
        <div className="flex items-end justify-between page-header-pb">
          <div className="flex items-center space-x-2">
            <button
              onClick={(e) => {
                e.preventDefault();
                parentNavigate(lastRoute);
              }}
              className="back-arrow"
            >
              <ArrowLeft />
            </button>
            <div>
              <Breadcrumbs
                crumbs={[
                  { name: t("lang_dashboard"), path: `/dashboard` },
                  { name: t("lang_Reviews"), path: "/reviews" },
                  {
                    name: t("lang_Perticular_Product_Review"),
                    path: "/reviews/perticuler-review",
                  },
                ]}
              />
              <h4 className="text-xl md:text-2xl font-semibold text-primary">
                {t("lang_Reviews")}{" "}
              </h4>
            </div>
          </div>
        </div>

        <div className="flex w-full h-full overflow-hidden relative flex-col">
          <CommonTable
            tableHeader={tableHeader}
            tableFooter={tableFooter}
            columns={columns}
            data={displayRecords}
            loading={dataLoading && !ProdutReviews}
            skeletonRows={10}
            rowClassName={(row) =>
              selectedRowsId?.find((x) => x === row?._id) ? "selected-row" : ""
            }
            containerClassName="w-full transition-all duration-100 border main-border-color  inline-block overflow-x-auto overflow-y-hidden rounded-[8px] shadow-sm"
          />

          <Popover
            open={filter}
            anchorEl={anchorEl}
            onClose={() => {
              setFilter(false);
              setAnchorEl(null);
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            PaperProps={{
              style: { marginRight: "35px", marginTop: "10px" },
            }}
            className="rounded-[6px]"
          >
            <div className="p-[20px] filter min-w-[280px]">
              <div>
                <div className="flex justify-between items-center">
                  <p className="flex font-semibold  text-sm m-0 items-center">
                    <Filter className="me-1 w-4 h-4" />
                    {t("lang_filter")}
                  </p>
                  <ButtonComponent
                    variant="secondary"
                    size="sm"
                    onClick={(e) => resetFilter(e)}
                  >
                    {t("lang_reset_filter")}
                  </ButtonComponent>
                </div>
                <hr className="main-border-color my-3" />
                <div className="grid gap-y-4">
                  <div>
                    <SelectComponent
                      label={t("lang_Reviews_Type")}
                      options={reviewTypeOptions}
                      value={allReviewname}
                      onChange={(e) => {
                        setPage(1);
                        setAllReviewname(e.target.value);
                      }}
                      searchable={false}
                    />
                  </div>
                  <div>
                    <SelectComponent
                      label={t("lang_set_items_limit")}
                      options={limitOptions}
                      value={limit}
                      onChange={(e) => {
                        setPage(1);
                        setLimit(e.target.value);
                      }}
                      searchable={false}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Popover>
        </div>
      </div>

      <Dialog
        open={popUp}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setPopUp(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="flex flex-col max-h-[80vh] min-w-[400px] [@media_(max-width:464px)]:min-w-[295px]">
          <div className="overflow-hidden w-full p-5">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center">
                <div className="h-10 w-10 rounded-full overflow-hidden">
                  <img
                    className="h-full w-full object-cover object-top rounded-full"
                    onError={(e) => {
                      e.target.src = NOUSER_IMAGE;
                    }}
                    src={popdata?.image || NOUSER_IMAGE}
                    alt={popdata?.name}
                  />
                </div>
                <p className="m-2 font-medium">{popdata?.name}</p>
              </div>
              <X
                className="text-link w-4 h-4 cursor-pointer transition-all duration-300"
                onClick={(e) => {
                  e.preventDefault();
                  setPopUp(false);
                }}
              />
            </div>
            <div className="flex items-center justify-between mt-4">
              <div>
                {popdata?.rating === 5 ? (
                  <div className="flex items-center space-x-2 bg-[#00b67a] text-white px-3 py-0.5 rounded-[6px]">
                    <StarFill />
                    <p className="font-medium text-sm">{popdata?.rating}</p>
                  </div>
                ) : popdata?.rating >= 4 && popdata?.rating < 5 ? (
                  <div className="flex items-center space-x-2 bg-[#73cf11] text-white px-3 py-0.5 rounded-[6px]">
                    <StarFill />
                    <p className="font-medium text-sm">{popdata?.rating}</p>
                  </div>
                ) : popdata?.rating >= 3 && popdata?.rating < 4 ? (
                  <div className="flex items-center space-x-2 bg-[#ffce00] text-white px-3 py-0.5 rounded-[6px]">
                    <StarFill />
                    <p className="font-medium text-sm">{popdata?.rating}</p>
                  </div>
                ) : popdata?.rating >= 2 && popdata?.rating < 3 ? (
                  <div className="flex items-center space-x-2 bg-[#ff8622] text-white px-3 py-0.5 rounded-[6px]">
                    <StarFill />
                    <p className="font-medium text-sm">{popdata?.rating}</p>
                  </div>
                ) : popdata?.rating < 2 ? (
                  <div className="flex items-center space-x-2 bg-[#ff3722] text-white px-3 py-0.5 rounded-[6px]">
                    <StarFill />
                    <p className="font-medium text-sm">{popdata?.rating}</p>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <p className="ml-3">{popdata?.review_date ? popdata?.review_date.split("T")[0] : ""}</p>
            </div>
            <div className="font-medium text-left block mt-4">
              {popdata?.review ? (
                <p className="text-sm whitespace-pre-wrap">{popdata.review}</p>
              ) : (
                <div
                  className="text-sm whitespace-pre-wrap"
                  dangerouslySetInnerHTML={{ __html: popdata?.description }}
                />
              )}
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default PerticularReviews;
